import { PaletteMode, ThemeOptions } from '@mui/material';
import { createTheme } from '@mui/material/styles';

const getDesignTokens = (mode: PaletteMode): ThemeOptions => ({
  palette: {
    mode,
    primary: {
      main: '#0c4d97', 
      light: 'hsl(219, 84%, 44%)',
      dark: '#112c5f',
      contrastText: '#fff',
    },
    secondary: {
      main: 'hsl(197, 36%, 65%)', // Brown
      light: 'hsl(197, 36%, 85%)',
      dark: 'hsl(197, 36%, 35%)',
      contrastText: '#fff',
    },
    background: {
      default: mode === 'light' ? '#F5F5F5' : '#121212',
      paper: mode === 'light' ? '#e7effe' : '#1E1E1E',
    },
    text: {
      primary: mode === 'light' ? '#3e4b5f' : '#fff',
      secondary: mode === 'light' ? '#001b4dff' : '#fff',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
    },
    h2: {
      fontWeight: 600,
    },
    h3: {
      fontWeight: 600,
    },
    h4: {
      fontWeight: 600,
    },
    h5: {
      fontWeight: 500,
    },
    h6: {
      fontWeight: 500,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
          variants: [],
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
        },
      },
    },
  },
});

export const createAppTheme = (mode: PaletteMode) => {
  return createTheme(getDesignTokens(mode));
}; 